import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["title"];
import * as React from 'react';
export default (function (_ref) {
  var title = _ref.title,
    extra = _objectWithoutProperties(_ref, _excluded);
  return (
    /*#__PURE__*/
    // $FlowFixMe[cannot-spread-inexact]
    React.createElement("svg", _extends({
      height: "50",
      width: "50",
      viewBox: "0 0 50 50"
    }, extra), title, /*#__PURE__*/React.createElement("path", {
      d: "M6.676 3.184l36.62-.004c1.448.148 2.558 1.318 2.692 2.778l.012.296v21.882C46 38.228 29.69 47.81 26.418 49.63a2.91 2.91 0 01-2.856-.012l-1.166-.678C17.612 46.086 4.528 37.5 4.016 28.666L4 28.136V6.254c0-1.584 1.15-2.902 2.676-3.07"
    }), /*#__PURE__*/React.createElement("path", {
      fill: "#FFF",
      d: "M21.059 21.768h3.228c1.976 0 3.23-.088 3.77-.26.538-.174.974-.524 1.308-1.05.336-.526.504-1.228.504-2.1 0-.836-.168-1.51-.504-2.018a2.54 2.54 0 00-1.362-1.05c-.406-.132-1.584-.198-3.536-.198h-3.408v6.676zm-4.344 15.18V10.642h9.17c2.344 0 4.02.238 5.024.71 1.006.472 1.83 1.29 2.476 2.456.646 1.168.968 2.566.968 4.192 0 2.058-.492 3.714-1.48 4.97-.986 1.256-2.388 2.046-4.206 2.368.934.67 1.704 1.402 2.314 2.198.61.796 1.442 2.222 2.494 4.28l2.62 5.132H30.9l-3.152-5.724c-1.134-2.07-1.904-3.364-2.314-3.886-.406-.52-.834-.878-1.29-1.076-.456-.198-1.184-.294-2.19-.294h-.896v10.98h-4.344z"
    }))
  );
});